import { WidgetTypes } from "@swiggy-private/dls-react-mxn/dist/WidgetController/constants";
import type { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import type { IAnalytics } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";
import type { IParentOrderListAnalyticsSupplement } from "./types";
import { hasType } from "../Menu";
import { WidgetTypes as PortalWidgetTypes } from "../Menu/types";
import { mergeAnalyticsContext } from "../utils";

const STICKY_FOOTER_TYPES: string[] = [
    WidgetTypes.CTA_LIST,
    PortalWidgetTypes.CART_UNAVAILABLE_ITEMS_FOOTER,
];

export const hasCTAWidget = (cards: IPLWidgetControllerCards[]) => {
    return cards.some(
        (card) => hasType(card) && STICKY_FOOTER_TYPES.includes(card.card.card["@type"] as string)
    );
};

export const enrichParentOrderListWidgetCards = (
    cards: IPLWidgetControllerCards[],
    supplement: IParentOrderListAnalyticsSupplement
): IPLWidgetControllerCards[] => {
    return cards.map((item) => {
        if (
            !hasType(item) ||
            item.card.card["@type"] !== PortalWidgetTypes.PARENT_ORDER_LIST_WIDGET
        ) {
            return item;
        }
        const analytics = (item.card.card as { analytics?: IAnalytics }).analytics;
        return {
            ...item,
            card: {
                ...item.card,
                card: {
                    ...item.card.card,
                    analytics: mergeAnalyticsContext(analytics, supplement),
                } as unknown as typeof item.card.card,
            },
        };
    });
};
